// @ts-ignore
import { Elm as ElmMain } from "./elm/Main.elm";
import { Elm as ElmError } from "./elm/Error.elm";
import { User, UserManager } from "oidc-client-ts";

// @ts-ignore
const config = window.config;

const url = window.location.origin;

/**
 * @type {import("oidc-client-ts").UserManagerSettings}
 */
const oidcSettings = {
  authority: config.keycloakRealm,
  client_id: config.keycloakClientId,
  redirect_uri: url + "/callback",
  response_type: "code",
  post_logout_redirect_uri: url + "/logout",
  automaticSilentRenew: true,
};

/**
 * @type {import("oidc-client-ts").UserManager}
 */
const userManager = new UserManager(oidcSettings);

class ChartjsChart extends window.HTMLElement {
  constructor() {
    const self = super();
    this._chartConfig = {};
    // @ts-ignore
    return self;
  }

  connectedCallback() {
    const canvas = document.createElement("canvas");
    this._canvas = canvas;
    this.appendChild(canvas);

    const ctx = canvas.getContext("2d");
    this.style.display = "block";
    // @ts-ignore
    this._chart = new window.Chart(ctx, this._chartConfig);
  }
  // @ts-ignore
  set chartConfig(newValue) {
    this._chartConfig = newValue;

    if (this._chart) {
      const newDatasets = newValue.data.datasets;
      const oldDatasets = this._chart.data.datasets;

      // Update all datasets
      for (let i = 0; i < newDatasets.length; i++) {
        // Copying the meta will keep the animations between them smooth
        if (oldDatasets[i]) {
          newDatasets[i]._meta = oldDatasets[i]._meta;
        }
        oldDatasets[i] = newDatasets[i];
      }

      // Update options and then call ChartJs update
      this._chart.options = newValue.options;
      this._chart.data = newValue.data;
      this._chart.update();
    }
  }
}

window.customElements.define("chart-component", ChartjsChart);

/**
 *
 * @param {number} expiresIn
 * @returns {number} expiresAt
 */
const expiresInToExpiresAt = (expiresIn) =>
  expiresIn * 3600000 + new Date().getTime();

/**
 *
 * @param {HTMLElement} e
 * @param {string} buttonIdToLookFor
 * @param {number} ancestorEndurance
 *
 * @returns {boolean}
 */
const closestWithLimit = (e, buttonIdToLookFor, ancestorEndurance) => {
  if (!e || ancestorEndurance <= 0) {
    return false;
  }
  if (e.id == buttonIdToLookFor) {
    return true;
  } else {
    const decreasedEndurance = ancestorEndurance - 1;
    // @ts-ignore
    return closestWithLimit(
      e.parentNode,
      buttonIdToLookFor,
      decreasedEndurance,
    );
  }
};

/**
 *
 * @param {Flags?} flags
 */
const startApp = (flags) => {
  const app = ElmMain.Main.init({ flags });

  /**
   * @constant {HTMLBodyElement}
   */
  const bodyElement = document.getElementsByTagName("body")[0];
  bodyElement.addEventListener("click", bodyOnClickHandler, true);
  bodyElement.addEventListener("dragover", (ev) => ev.preventDefault(), true);

  /**
   *
   * @param {MouseEvent} e
   */
  function bodyOnClickHandler(e) {
    handleCopyButton(e.target, 6);
    const buttonIdToLookFor = "copy-calc-values";
    // Avoid more elegant/standard solution with e.target.closest due to performance issues
    // since *all* click events inside body will run this code
    // This means that this is easily-broken by html changes
    var ancestorEndurance = 6;
    // @ts-ignore
    if (closestWithLimit(e.target, buttonIdToLookFor, ancestorEndurance)) {
      var copyText = document.querySelector(
        "#" + buttonIdToLookFor + "-hidden",
      );
      // @ts-ignore
      copyText.select();
      document.execCommand("copy");
    }
  }

  /**
   * @param {MouseEvent} e
   * @param {Integer} endurance
   * @returns {undefined}
   *
   * this is needed because elm messages aren't user initiated and some browsers
   * block access to the clipboard when it's not a user-initiated event.
   */
  function handleCopyButton(e, endurance) {
    if (endurance <= 0) {
      return;
    }
    const magicCopyClass = "copy-button";
    // @ts-ignore
    if (e && e.classList && !e.classList.contains(magicCopyClass)) {
      return handleCopyButton(e.parentNode, endurance - 1);
    }
    // @ts-ignore
    const copyButtonId = e.id;
    if (!copyButtonId) return;
    const selector = "#" + copyButtonId + "-text";
    var copyText = document.querySelector(selector);
    // @ts-ignore
    copyText.select();
    document.execCommand("copy");
  }

  app.ports.logout.subscribe(function () {
    userManager.removeUser();
    // redirect to the logout page
    userManager.signoutRedirect({ post_logout_redirect_uri: url + "/logout" });
  });

  app.ports.login.subscribe(function () {
    userManager.signinRedirect();
  });

  app.ports.openInNewTab.subscribe((url) => window.open(url, "_blank"));

  app.ports.setSelectedOrganization.subscribe((orgId) =>
    sessionStorage.setItem("carboncloud-selected-org", orgId),
  );

  app.ports.dragStart.subscribe((event) => {
    event?.dataTransfer.setDragImage(event.target, 110, 40); // Magic number to center image
  });

  userManager.events.addUserLoaded((user) => {
    app.ports.newAuthToken.send(user.access_token);
  });

  // A PROACTIVE background renewal (automaticSilentRenew) failing is not proof
  // of a dead session — it is routinely a transient network blip or a
  // momentarily-unreachable IdP. Do NOT force a logout here; just log it and let
  // the reactive refresh-on-401 path recover the token on the next real request.
  userManager.events.addSilentRenewError((error) => {
    console.warn("Silent token renewal failed (will recover on next request):", error);
  });

  // Reactive refresh-on-401, guarded against an invisible refresh/reload loop.
  // This is a best-effort circuit breaker, not a proof of correctness; it rests
  // on the backend using 401 ONLY for token problems (permission failures must
  // be 403 — see the coordinated backend work). Three parts:
  //
  //  - `refreshInFlight` collapses the burst of concurrent 401s that the
  //    parallel page loads produce into a single signinSilent() call.
  //
  //  - A post-refresh COOLDOWN: after a signinSilent() settles we record
  //    `lastRefreshCompletedAt`. A refreshAuthToken arriving within COOLDOWN_MS
  //    is ignored (no refresh, no logout). This absorbs the straggler burst —
  //    original-token 401s issued before the refresh but arriving just after —
  //    and debounces rapid re-triggers.
  //
  //  - A consecutive-refresh counter with a quiet-gap reset: the counter only
  //    resets after QUIET_MS with no refresh activity (i.e. a recovery that
  //    actually stuck). So a persistent 401 that keeps re-triggering — at ANY
  //    frequency, not just tight loops — accumulates until it exceeds
  //    MAX_CONSECUTIVE_REFRESHES and we signal a dead session (-> logout) rather
  //    than looping forever. A healthy session whose token re-expires minutes
  //    later always sees a long quiet gap first, so the counter is back at 0 and
  //    it never falsely logs out. Known residual: a pathological burst of many
  //    genuinely-recovering 401 waves closer together than QUIET_MS could still
  //    escalate to a (safe) re-login — an accepted trade vs. per-request token
  //    epoch tracking, which this architecture can't do without a larger refactor.
  let refreshInFlight = false;
  let lastRefreshCompletedAt = 0;
  let consecutiveRefreshes = 0;
  const COOLDOWN_MS = 3000;
  const QUIET_MS = 30000;
  const MAX_CONSECUTIVE_REFRESHES = 8;

  app.ports.refreshAuthToken.subscribe(function () {
    if (refreshInFlight) {
      return;
    }
    const now = Date.now();
    if (now - lastRefreshCompletedAt < COOLDOWN_MS) {
      // A refresh just completed — this 401 is almost certainly a straggler
      // from a superseded token. Ignore it rather than kicking off another
      // refresh/reload wave.
      return;
    }
    if (now - lastRefreshCompletedAt > QUIET_MS) {
      // Long quiet gap since the last refresh — the previous recovery stuck, so
      // start a fresh count. This is what keeps a healthy session that simply
      // re-expires later from ever accumulating toward a false logout.
      consecutiveRefreshes = 0;
    }
    consecutiveRefreshes += 1;
    if (consecutiveRefreshes > MAX_CONSECUTIVE_REFRESHES) {
      // Many refreshes in close succession with no quiet recovery gap — the
      // token is not resolving the 401 (dead session, or a non-token 401 the
      // backend should render as 403). Stop looping and signal a dead session.
      consecutiveRefreshes = 0;
      app.ports.authRefreshError.send("error");
      return;
    }
    refreshInFlight = true;
    userManager
      .signinSilent()
      .then(function (user) {
        if (user) {
          // signinSilent() also emits addUserLoaded (-> newAuthToken), so the
          // session token is updated there too; this retryAuthToken send is the
          // one that additionally triggers the page reload. The double token
          // update is intentional and idempotent.
          app.ports.retryAuthToken.send(user.access_token);
        } else {
          // Resolved without a user — treat as a failed refresh, same as reject.
          app.ports.authRefreshError.send("error");
        }
      })
      .catch(function () {
        app.ports.authRefreshError.send("error");
      })
      .finally(function () {
        lastRefreshCompletedAt = Date.now();
        refreshInFlight = false;
      });
  });
};

/**
 *
 * @param {string} accessToken
 * @returns {Promise<Auth0UserProfile>}
 */
const getUserProfile = (accessToken) =>
  new Promise((resolve, reject) =>
    webAuth.client.userInfo(accessToken, function (err, user) {
      if (err) reject(err);
      else resolve(user);
    }),
  );

// Needed for the Safari bug below
/**
 * @param {number} ms
 * @returns {Promise<void>}
 */
async function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

/**
 *
 * @returns {Promise<Flags?>}
 */
const flags = () => {
  const currentPath = window.location.pathname;

  /**
   * @type {Promise<ExtendedUser | null>}
   */
  var getUser_ = null;
  if (currentPath === "/callback") {
    getUser_ = userManager
      .signinCallback(window.location.href)
      .then((response) => {
        // reset the URL
        window.history.replaceState({}, document.title, "/");
        return response;
      });
  } else if (currentPath === "/impersonate") {
    const urlParams = new URLSearchParams(window.location.search);

    const tokenString = /** @type {string | null} */ (urlParams.get("token"));
    if (tokenString) {
      const user = User.fromStorageString(tokenString);
      userManager
        .storeUser(user)
        .then(() => {})
        .catch((error) => {
          console.error("error storing user: ", error);
        });
      getUser_ = userManager.signinSilent();
    } else {
      console.error("token isn't there");
      window.location.href = "/"; // return to the login page - not the greatest UX, but it'll have to do
    }
  } else {
    getUser_ = userManager.getUser();
  }

  return new Promise((resolve, reject) =>
    getUser_.then((user) => {
      if (user) {
        const missingOrgError = {
          error: "Missing organization",
          errorDescription:
            "It seems like there are organizations available to be used within CarbonData.",
        };

        if (!user.profile?.organization) reject(missingOrgError);

        // Organizations are in the format "<org-id>:<org-name>"
        const groups = Object.values(user.profile?.organization).flatMap(
          (x) => {
            if (x?.auth0Groups)
              return x.auth0Groups.map((x) => x.split(":")[0]);
            else {
              return [];
            }
          },
        );

        if (groups.length === 0) reject(missingOrgError);

        // Roles are in the format "<role>"
        const roles = user.profile.resource_access.carboncloud.roles
          .map((x) => x.split(":"))
          .filter((x) => x.length === 1)
          .map((x) => x[0]);

        // Permissions are in the format "carbondata:permissions:<permission-type>"
        const permissions = user.profile.resource_access.carboncloud.roles
          .map((x) => x.split(":"))
          .filter((x) => x[0] === "carbondata" && x[1] === "permissions")
          .map((x) => x[2]);

        /**
         * @type {Flags}
         */
        const flag = {
          authToken: user.access_token,
          apiRoot: config.backend,
          userProfile: {
            userId: user.profile.sub || "",
            name: user.profile.name || "",
            email: user.profile.email || "",
            avatarUrl: user.profile.picture || "",
          },
          nominatimToken: config.nominatimToken,
          roles,
          permissions,
          groups,
          selectedOrganization: sessionStorage.getItem(
            "carboncloud-selected-org",
          ),
          climateApiRootUrl: config.climateApiRootUrl,
          climateHubRootUrl: config.climateHubRootUrl,
          climateLabelRootUrl: config.climateLabelRootUrl,
        };
        resolve(flag);
      }
      resolve(null);
    }),
  );
};

// Main function call that initializes and starts the application
flags()
  .then(startApp)
  .catch((err) => {
    console.log(err);
    const elmError = ElmError.Error.init({ flags: err });

    elmError.ports.logout.subscribe(function () {
      userManager.removeUser();
      // redirect to the logout page
      userManager.signoutRedirect({
        post_logout_redirect_uri: url + "/logout",
      });
    });
  });
